var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "square-exclamation",
    clipPath: "url(#clip0_789_4170)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.52246 2.5C2.24746 2.5 2.02246 2.725 2.02246 3V13C2.02246 13.275 2.24746 13.5 2.52246 13.5H12.5225C12.7975 13.5 13.0225 13.275 13.0225 13V3C13.0225 2.725 12.7975 2.5 12.5225 2.5H2.52246ZM0.522461 3C0.522461 1.89688 1.41934 1 2.52246 1H12.5225C13.6256 1 14.5225 1.89688 14.5225 3V13C14.5225 14.1031 13.6256 15 12.5225 15H2.52246C1.41934 15 0.522461 14.1031 0.522461 13V3ZM7.52246 4C7.93809 4 8.27246 4.33437 8.27246 4.75V8.25C8.27246 8.66563 7.93809 9 7.52246 9C7.10684 9 6.77246 8.66563 6.77246 8.25V4.75C6.77246 4.33437 7.10684 4 7.52246 4ZM6.52246 11C6.52246 10.7348 6.62782 10.4804 6.81535 10.2929C7.00289 10.1054 7.25724 10 7.52246 10C7.78768 10 8.04203 10.1054 8.22957 10.2929C8.4171 10.4804 8.52246 10.7348 8.52246 11C8.52246 11.2652 8.4171 11.5196 8.22957 11.7071C8.04203 11.8946 7.78768 12 7.52246 12C7.25724 12 7.00289 11.8946 6.81535 11.7071C6.62782 11.5196 6.52246 11.2652 6.52246 11Z",
    fill: "#DB2828"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareExclamation);
export default __webpack_public_path__ + "static/media/square-exclamation.4a373b212132ec3dcb720d44171d720d.svg";
export { ForwardRef as ReactComponent };